import React, { createContext, useContext, useState } from 'react';

const MessengerContext = createContext();

export const useMessenger = () => {
  const context = useContext(MessengerContext);
  if (!context) {
    throw new Error('useMessenger must be used within MessengerProvider');
  }
  return context;
};

export const MessengerProvider = ({ children }) => {
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState({});
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const [currentUser, setCurrentUser] = useState(null);
  const [socket, setSocket] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [employeeProfilePics, setEmployeeProfilePics] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <MessengerContext.Provider value={{
      conversations,
      setConversations,
      messages,
      setMessages,
      onlineUsers,
      setOnlineUsers,
      currentUser,
      setCurrentUser,
      socket,
      setSocket,
      isConnected,
      setIsConnected,
      employeeProfilePics,
      setEmployeeProfilePics,
      selectedUser,
      setSelectedUser,
    }}>
      {children}
    </MessengerContext.Provider>
  );
};